export default {
  unlocked_plural: 'Odblokowano {{count}} oferty',
  unlocked: 'Oferta {{offer}} została odblokowana',
  removed_one: 'Oferta {{offer}} została usunięta',
  removed_few: 'Usunięto {{count}} oferty',
  removed_many: 'Usunięto {{count}} ofert',
  removed_other: '{{count}} zostało usuniętych',
};
